import { useEffect } from 'react';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router';
import { constants } from '@/constants';
import { getSentryDsn, getViteMode, shouldInitSentry } from '@/_helpers/mainHelpers';

const env: ImportMetaEnv = import.meta.env;
const mode: string = getViteMode(env);
const dsn: string | undefined = getSentryDsn(env);

export async function initSentry(dsn: string): Promise<void> {
  const { init, reactRouterV7BrowserTracingIntegration, replayIntegration } = await import('@sentry/react');

  init({
    dsn,
    tunnel: constants.errorMonitoringUrl,
    debug: false,
    sendDefaultPii: true,
    integrations: [
      reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      replayIntegration(),
    ],
    tracesSampleRate: 0.2,
    tracePropagationTargets: ['localhost', /^https:\/\/testerly\.com\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

if (dsn && shouldInitSentry(mode, dsn)) {
  void initSentry(dsn);
}